import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import LocationAndCurrencyInfoComponent from '../../../../../../../components/location-and-currency-info';
import { SotyBadge } from 'src/areas/store/components/soty-badge-link/soty-badge';
import { H4Text } from '@prisjakt/ui/text/variants';

export const StyledExpandedInfo = styled.div`
  padding: ${layout.measurements.spacing100};
  display: flex;
  justify-content: space-between;

  @supports (display: grid) {
    display: grid;
    grid-template-columns: 1fr auto;
  }

  ${media.smallOnly`
    grid-template-columns: 1fr;
  `}

  > div {
    flex: 0 0 48%;

    .sentiment-badge--text > span {
      display: block;
      margin-left: 0;
    }
  }
`;

export const StyledStoreLink = styled(H4Text)`
  display: flex;
  align-items: center;
  margin-bottom: ${layout.measurements.spacing025};
  > svg > path {
    fill: currentColor;
  }
`;

export const StyledGeneralInfo = styled.div`
  grid-area: 2 / 1 / 3 / 3;
  display: flex;
  flex-direction: column;
  > h4,
  > div > h4 {
    margin-top: ${layout.measurements.spacing100};
  }
`;

export const StyledLocationAndCurrencyInfo = styled(
  LocationAndCurrencyInfoComponent
)`
  align-items: baseline;
`;

export const StyledSotyBadge = styled(SotyBadge)`
  margin: ${layout.measurements.spacing025};
  align-items: normal;

  ${media.smallOnly`
    max-width: 88px;
  `}
`;
